import { ACTIVITIES_0_2 } from "./age0_2";
import { ACTIVITIES_3_5 } from "./age3_5";
import { ACTIVITIES_6_9 } from "./age6_9";
import { ACTIVITIES_10_12 } from "./age10_12";
import { ACTIVITIES_13_PLUS } from "./age13plus";

export const ACTIVITIES = [
  ...ACTIVITIES_0_2,
  ...ACTIVITIES_3_5,
  ...ACTIVITIES_6_9,
  ...ACTIVITIES_10_12,
  ...ACTIVITIES_13_PLUS,
];
